import React from "react";
import { styled } from "@mui/system";

const StyledErrorText = styled("span")(() => ({
  color: "#da2e23",
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "left",
  fontSize: "0.9rem",
}));

const ErrorMessage = ({ children }) => (
  <StyledErrorText>{children}</StyledErrorText>
);

export default ErrorMessage;
